<template>
  <v-row>
    <v-col cols="12">
      <spam-threshold-score :pending="pending" />
    </v-col>
<!--    <v-col cols="12">-->
<!--      <spam-protection-settings :pending="pending" />-->
<!--    </v-col>-->
  </v-row>
</template>

<script>
// import SpamProtectionSettings from '@/components/Services/Hosting/Shared/Email/SpamFilters/SpamProtectionSettings'
import SpamThresholdScore from '@/components/Services/Hosting/Shared/Email/SpamFilters/SpamThresholdScore'

import { mapActions } from 'vuex'

export default {
  name: 'SpamFiltersView',
  components: {
    // SpamProtectionSettings,
    SpamThresholdScore
  },
  data: () => ({
    pending: false
  }),
  created () {
    this.getSettings()
  },
  methods: {
    ...mapActions({
      getSpamSettings: 'spam_filters/getSpamSettings',
      getUserPreferences: 'spam_filters/getUserPreferences',
      reportError: 'reportError'
    }),
    async getSettings () {
      try {
        this.pending = true
        await this.getSpamSettings()
        await this.getUserPreferences()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.pending = false
      }
    },
  }
}
</script>

<style scoped>

</style>
